/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportingMelcoMachineStatisticsModelsMachineListItem,
    ReportingMelcoMachineStatisticsModelsMachineListItemFromJSON,
    ReportingMelcoMachineStatisticsModelsMachineListItemFromJSONTyped,
    ReportingMelcoMachineStatisticsModelsMachineListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReportingMelcoMachineStatisticsModelsUpdateGroup
 */
export interface ReportingMelcoMachineStatisticsModelsUpdateGroup {
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoMachineStatisticsModelsUpdateGroup
     */
    name?: string | null;
    /**
     * 
     * @type {Array<ReportingMelcoMachineStatisticsModelsMachineListItem>}
     * @memberof ReportingMelcoMachineStatisticsModelsUpdateGroup
     */
    machine_list?: Array<ReportingMelcoMachineStatisticsModelsMachineListItem> | null;
}

export function ReportingMelcoMachineStatisticsModelsUpdateGroupFromJSON(json: any): ReportingMelcoMachineStatisticsModelsUpdateGroup {
    return ReportingMelcoMachineStatisticsModelsUpdateGroupFromJSONTyped(json, false);
}

export function ReportingMelcoMachineStatisticsModelsUpdateGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoMachineStatisticsModelsUpdateGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'machine_list': !exists(json, 'machine_list') ? undefined : (json['machine_list'] === null ? null : (json['machine_list'] as Array<any>).map(ReportingMelcoMachineStatisticsModelsMachineListItemFromJSON)),
    };
}

export function ReportingMelcoMachineStatisticsModelsUpdateGroupToJSON(value?: ReportingMelcoMachineStatisticsModelsUpdateGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'machine_list': value.machine_list === undefined ? undefined : (value.machine_list === null ? null : (value.machine_list as Array<any>).map(ReportingMelcoMachineStatisticsModelsMachineListItemToJSON)),
    };
}


